import { render, staticRenderFns } from "./CreateSubscriptionForm.vue?vue&type=template&id=fa5ae860"
import script from "./CreateSubscriptionForm.vue?vue&type=script&lang=ts"
export * from "./CreateSubscriptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports